<template>
  <div class="main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="root-view" v-if="!$route.meta.keepAlive"></router-view>

    <div class='loading' v-if='isLoading'>
      <p class='tip-info'>加载中...</p>
    </div>
    <div class="mui-popup-backdrop mui-active" v-if='isLoading'></div>
  </div>
</template>

<script>
  import {IS_IOS} from './utils/useragent'
  export default {
    data () {
      return {
        transitionName: 'slide',
        isIos: false
      }
    },
    mounted: function () {
      this.isIos = IS_IOS
    },
    watch: {
      '$route' (to, from) {
      }
    },
    computed: {
      direction () {
        return this.$store.state.pages.direction
      },
      isLoading () {
        return this.$store.state.pages.isLoading
      }
    }
  }
</script>
<style lang='less' scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 3s ease;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .root-view {
    position: absolute;
    transition: all .2s linear;
  }

  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    transform: translate(100%, 0);
  }

  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    transform: translate(-100%, 0);
  }

  .loading {
    position: fixed;
    z-index: 50000;
    width: 240px;
    min-height: 240px;
    top: 360px;
    left: 50%;
    margin-left: -120px;
    text-align: center;
    border-radius: 15px;
    color: #fff;
    background: url(./assets/images/loading.gif) center 50px no-repeat;
    background-size: 80px;
    background-color: rgba(40, 40, 40, .75);

  .tip-info {
    margin-top: 66%;
    font-size: 28px;
    color: #fff;
  }

  }
</style>



// WEBPACK FOOTER //
// App.vue?f555579a